export default __webpack_public_path__ + "static/programming2-123baedbdd20af3b5de7540da00ac22b.png";